__turbopack_context__.v({
  "culture": "collection-object-module-scss-module__Ytp5aq__culture",
});
